var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddComponent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2794_3670",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2794_3670)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2501 21.2502V26.667C19.2501 27.0211 19.3699 27.318 19.6096 27.5575C19.8492 27.7971 20.1462 27.9169 20.5006 27.9169C20.8549 27.9169 21.1517 27.7971 21.391 27.5575C21.6303 27.318 21.75 27.0211 21.75 26.667V21.2502H27.1667C27.5208 21.2502 27.8177 21.1304 28.0573 20.8907C28.2969 20.6511 28.4166 20.354 28.4166 19.9997C28.4166 19.6454 28.2969 19.3486 28.0573 19.1093C27.8177 18.87 27.5208 18.7503 27.1667 18.7503H21.75V13.3336C21.75 12.9795 21.6301 12.6826 21.3905 12.443C21.1508 12.2034 20.8538 12.0837 20.4995 12.0837C20.1451 12.0837 19.8483 12.2034 19.609 12.443C19.3697 12.6826 19.2501 12.9795 19.2501 13.3336V18.7503H13.8333C13.4792 18.7503 13.1823 18.8702 12.9428 19.1098C12.7032 19.3495 12.5834 19.6465 12.5834 20.0008C12.5834 20.3552 12.7032 20.652 12.9428 20.8913C13.1823 21.1306 13.4792 21.2502 13.8333 21.2502H19.2501ZM20.5028 35.8336C18.3129 35.8336 16.2545 35.418 14.3276 34.5869C12.4007 33.7558 10.7246 32.6279 9.29922 31.2032C7.87383 29.7784 6.7454 28.103 5.91393 26.177C5.08245 24.2509 4.66672 22.193 4.66672 20.0031C4.66672 17.8132 5.08227 15.7548 5.91338 13.8279C6.7445 11.901 7.87241 10.2249 9.29713 8.7995C10.7219 7.37411 12.3973 6.24567 14.3233 5.4142C16.2494 4.58273 18.3073 4.16699 20.4972 4.16699C22.6871 4.16699 24.7455 4.58255 26.6724 5.41366C28.5993 6.24477 30.2754 7.37269 31.7008 8.79741C33.1262 10.2222 34.2546 11.8976 35.0861 13.8236C35.9176 15.7496 36.3333 17.8076 36.3333 19.9975C36.3333 22.1874 35.9177 24.2458 35.0866 26.1727C34.2555 28.0996 33.1276 29.7757 31.7029 31.2011C30.2781 32.6265 28.6027 33.7549 26.6767 34.5864C24.7507 35.4178 22.6927 35.8336 20.5028 35.8336Z",
    fill: "#B6B6B6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddComponent);
export default __webpack_public_path__ + "static/media/add_component.5fce996c096d032d649f6b627740c20e.svg";
export { ForwardRef as ReactComponent };